import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { VoucherDetailPage } from './voucher-detail.page';

const routes: Routes = [
  {
    path: '',
    component: VoucherDetailPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VoucherDetailPageRoutingModule {}
